"use client";

import { ImgHTMLAttributes } from "react";

import { useTheme } from "@/components/providers/ThemeProvider";
import { SITE_LOGO_BLACK_SRC, SITE_LOGO_WHITE_SRC } from "@/data/constants";

type ThemeLogoProps = ImgHTMLAttributes<HTMLImageElement> & {
  /** `light` = black logo on light bg; `dark` = white logo on dark bg; `auto` follows theme. */
  variant?: "auto" | "light" | "dark";
};

export default function ThemeLogo({
  variant = "auto",
  className = "",
  alt,
  ...props
}: ThemeLogoProps) {
  const { darkMode } = useTheme();

  const src =
    variant === "dark" || (variant === "auto" && darkMode)
      ? SITE_LOGO_WHITE_SRC
      : SITE_LOGO_BLACK_SRC;

  return <img src={src} alt={alt} className={className} {...props} />;
}
